export enum MatchType {
    Live,
    Manual
}

export class Configuration {
    matchId: number;
    matchType: number;
    league: number;
    homeTeam: number;
    awayTeam: number;
    isNational: boolean;

    isValid() {
        return this.matchId > 0 && this.matchType in MatchType && this.league > 0 && this.homeTeam > 0 && this.awayTeam > 0;
    }
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/configuration.model.ts